import { render, staticRenderFns } from "./MocktestPreview.vue?vue&type=template&id=09017d3e&"
import script from "./MocktestPreview.vue?vue&type=script&lang=js&"
export * from "./MocktestPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports